<template>
  <el-form
    :model="editForm"
    ref="editForm"
    :rules="rules"
    label-width="100px"
    :hide-required-asterisk="false"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <el-row>
      <el-col :span="24">
        <el-row>
          <el-col :span="24" style="margin-top: 15px">
            <el-row>
              <el-col :span="8">
                <el-form-item label="完成进度" prop="progress">
                  <el-input
                    placeholder="请输入内容"
                    v-model="editForm.progress"
                    @change="handleChangeProgress"
                    maxlength="3"
                  >
                    <template slot="append"><div>%</div></template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="解决方案" prop="solvePlan">
                  <el-select
                    ref="solvePlan"
                    v-model="editForm.solvePlan"
                    placeholder="请选择解决方案"
                    clearable
                    filterable
                    :disabled="
                      editForm.progress != 0 && editForm.progress != 100
                    "
                    @change="handeleChangeSolvePlan"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in solvePlanList"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="解决日期" prop="solveTime">
                  <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    v-model="editForm.solveTime"
                    style="width: 100%"
                    :clearable="false"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="实际工作量" prop="realWorkload" key="6">
                  <el-input
                    placeholder="请输入内容"
                    v-model="editForm.realWorkload"
                  >
                    <template slot="append"><div>小时</div></template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="解决版本" prop="solveVersion" key="6">
                  <el-input
                    show-word-limit
                    placeholder="如：V1.6.3"
                    maxLength="40"
                    v-model="editForm.solveVersion"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="上线时间" prop="sxsj">
                  <div style="position: relative">
                    <span
                      style="position: absolute; left: -77px; color: #f56c6c"
                      v-if="editForm.sfxytx == 1 && editForm.solvePlan == 4"
                      >*</span
                    >
                    <el-date-picker
                      type="date"
                      placeholder="选择日期"
                      v-model="editForm.sxsj"
                      style="width: 100%"
                      :clearable="true"
                    ></el-date-picker>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <el-tabs v-model="activeEditor" @tab-click="handleClickTabs">
              <el-tab-pane label="详细描述" name="0">
                <span>
                  <div id="wangEditor_edit"></div>
                </span>
              </el-tab-pane>
              <el-tab-pane label="解决方案" name="1">
                <span>
                  <div id="wangEditor2_edit"></div>
                </span>
              </el-tab-pane>
            </el-tabs>
          </el-col>
          <el-col style="line-height: 40px">附件</el-col>
          <el-col :span="24" style="margin-top: 15px">
            <el-row>
              <el-col :span="6">
                <!-- <el-form-item key="12"> -->
                <el-upload
                  action="#"
                  class="upload-demo"
                  ref="upload"
                  :headers="headers"
                  :on-change="handleChange"
                  :on-exceed="handleExceed"
                  :file-list="fileList"
                  :auto-upload="false"
                  multiple
                  :limit="5"
                >
                  <el-button type="primary" icon="el-icon-upload" plain
                    >选择附件</el-button
                  >
                </el-upload>
                <!-- </el-form-item> -->
              </el-col>
              <el-col :span="16" style="line-height: 40px">
                <div>(单个文件不能超过50M，支持所有扩展名)</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <!-- <el-form-item label=""> -->
            <el-table
              :data="editForm.file"
              fit
              highlight-current-row
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
            >
              <el-table-column
                label="文件名称"
                align="left"
                prop="filename"
                min-width="250px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <el-link @click="openPreview(scope.row)" type="primary">{{
                    scope.row.filename
                  }}</el-link>
                </template>
              </el-table-column>
              <el-table-column
                label="上传时间"
                align="left"
                prop="uploadtime"
                min-width="200px"
                :show-overflow-tooltip="true"
              />

              <el-table-column
                label="上传阶段"
                align="left"
                prop="fileSize"
                min-width="200px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.xm }}{{ scope.row.remark }}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                align="left"
                min-width="100px"
                :show-overflow-tooltip="true"
                fixed
              >
                <template slot-scope="scope">
                  <el-button type="text" @click="handleDownloadFile(scope.row)"
                    >下载</el-button
                  >
                </template>
              </el-table-column>
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
            <!-- </el-form-item> -->
          </el-col>
          <el-col
            style="
              line-height: 40px;
              display: flex;
              margin: 15px 0;
              justify-content: space-between;
            "
          >
            <div>
              <span style="font-weight: 700; font-size: 16px">评论</span> 共{{
                editForm.pinglun.length
              }}条评论
            </div>
            <el-button type="primary" @click="handleAddComment">评论</el-button>
          </el-col>
          <el-col :span="24">
            <span><div id="wangEditor3"></div></span>
          </el-col>
          <el-col>
            <div
              v-for="item in editForm.pinglun"
              :key="item.id"
              class="zpsm-comment-item"
            >
              <div class="top">
                <div>{{ item.username ? item.username[0] : "" }}</div>
                <div>{{ item.username }}</div>
              </div>
              <div class="middle">
                <div>
                  <span
                    v-for="(picItem, picIndex) in item.commnetSlice"
                    :key="picIndex"
                  >
                    <span v-if="picItem && picItem.picBig">
                      <span>
                        <el-image
                          style="max-width: 200px"
                          :src="picItem.srcBig"
                          :preview-src-list="[picItem.srcBig]"
                        >
                        </el-image>
                      </span>
                    </span>
                    <span v-else v-html="picItem"></span>
                  </span>
                </div>
              </div>
              <div class="bottom">
                {{ item.create_time }}
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {
  formatMomentDate,
  checkVal,
  cutContent,
  getPicList,
} from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";

import {
  getDictData,
  submitUpload,
  getQuestionDetail,
  saveComment,
  solveQuestion,
  uploadFile,
} from "@/api/question.js";
import { getXmxxList } from "@/api/itWeekly";

import { fetchQuestionTx } from "@/api/common.js";
import wangEditor from "wangeditor";

export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "question"]),
  },
  props: ["mxParams"],
  data() {
    var checkProgress = (rule, value, callback) => {
      if (!value && this.editForm.solvePlan == 4) {
        return callback(new Error("完成进度不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (+value < 0 || +value > 100) {
            callback(new Error("请输入0到100的数字值"));
          } else {
            callback();
          }
        }
      }, 10);
    };
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      form: {
        rldxActive: 1,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      headers: {
        "x-token": localStorage.getItem("token"),
      },

      fileList: [],
      rules: {
        progress: [
          { required: true, validator: checkProgress, trigger: "blur" },
        ],
        solveTime: [
          { required: true, message: "解决日期不能为空", trigger: "change" },
        ],
        realWorkload: [
          { required: true, message: "实际工作量不能为空", trigger: "blur" },
        ],
      },
      editForm: {
        title: null,
        status: null,
        sort: null,
        questionLevel: null,
        line: null,
        xmbh: null,
        productVersion: null,
        module: null,
        influenceVersion: null,
        designee: null,
        content: null,
        finishTime: "",
        planTime: null,
        detail: null,
        jjfa: null,
        fileIds: null,
        designeeName: null,
        pinglun: [],
        endTime: null,
        progress: 0,
        realWorkload: 0,
        sxsj: false,
      },

      txList: [],
      xmList: [],
      sortList: [],
      bmList: [],
      statusList: [],
      yzcdList: [],
      solvePlanList: [],
      data2: {
        type: 2, //说明：类型1 总部-分公司 2分公司-总部
        htlx: "0", //说明：合同类型，多个,隔开，如DS,SW,SD,TS
        range: 0, //说明：数据范围 1-角色数据权限 0-全部
        htzt: "0",
        //htzt: "1,2,3,4,5", //合同状态，多个,隔开，如1,3
      },
      activeEditor: "1",
      parentDialog: false,
      fullscreenLoading: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    fetchQuestionTx().then((res) => {
      if (res.code == 0) {
        this.txList = res.data;
      }
    });
    getXmxxList(
      this.data2.htlx,
      this.data2.range,
      this.data2.htzt,
      "",
      ""
    ).then((res) => {
      if (res.code == 0) {
        this.xmList = res.data;
      }
    });
    getDictData("pmp_quality_sort", 1).then((res) => {
      if (res.code === 0) {
        this.sortList = res.data;
      }
    });
    getDictData("pmp_quality_status", 1).then((res) => {
      if (res.code === 0) {
        this.statusList = res.data;
      }
    });
    getDictData("pmp_quality_type", 1).then((res) => {
      if (res.code === 0) {
        this.yzcdList = res.data;
      }
    });
    getDictData("pmp_solve_plan", 1).then((res) => {
      if (res.code === 0) {
        this.solvePlanList = res.data;
      }
    });
    this.getData();
  },
  mounted() {
    let editor = new wangEditor(`#wangEditor_edit`);
    let editor2 = new wangEditor(`#wangEditor2_edit`);
    let editor3 = new wangEditor(`#wangEditor3`);

    editor = this.editorConfig(editor);
    editor2 = this.editorConfig(editor2);
    editor3 = this.editorConfig(editor3, 150);

    this.editor = editor;
    this.editor2 = editor2;
    this.editor3 = editor3;
  },
  methods: {
    getData(isComment) {
      getQuestionDetail({ id: this.mxParams.id }).then((res) => {
        if (res.code == 0) {
          if (isComment) {
            this.editForm.pinglun = res.data.pinglun;
          } else {
            this.editForm = res.data;

            this.editForm.solveVersion = res.data.productVersion;
            if (this.editForm.solveTime) {
              this.editForm.solveTime = moment(this.editForm.solveTime + "");
            } else {
              this.editForm.solveTime = moment();
            }
            if (this.editForm.sxsj) {
              this.editForm.sxsj = moment(this.editForm.sxsj + "");
            }
          }
          if (this.editForm.pinglun && this.editForm.pinglun.length > 0) {
            for (let i in this.editForm.pinglun) {
              const picList = getPicList(this.editForm.pinglun[i].content);
              this.editForm.pinglun[i].commnetSlice = cutContent(
                picList,
                this.editForm.pinglun[i].content
              );
            }
          }
          this.editor.txt.html(this.editForm.detail);
          this.editor2.txt.html(this.editForm.jjfa);
        }
      });
    },
    editorConfig(editor, height) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = height ? height : 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中
      // editor.config.onchange = function () {
      //   if (editor.txt.html() == "") {
      //     editor.txt.html("&nbsp");
      //   }
      // };

      editor.create();
      return editor;
    },
    saveForm() {
      let sxsj = null;
      if (this.editForm.sxsj) {
        sxsj = formatMomentDate(new Date(this.editForm.sxsj));
      }

      const params = {
        ...this.editForm,
        solveTime: formatMomentDate(new Date(this.editForm.solveTime)),
        sxsj,
      };
      if (this.editor3.txt.html()) {
        saveComment({
          id: this.mxParams.id,
          status: this.editForm.status,
          content: this.editor3.txt.html(),
        });
      }
      solveQuestion(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$store.dispatch(
            "question/fetchQuestionListAction",
            this.question.questionList.params
          );
          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message.error(res.msg);
        }
        this.fullscreenLoading = false;
      });
    },
    resetFrom() {
      this.editForm = {
        ...this.editForm,
        ...{
          jf: null,
          title: null,
          rldx: 1,
          ygbhs: null,
          bmbhs: null,
          txlxs: null,
          rwsm: null,
          yqjg: null,
          jsrq: null,
          gs: 0,
          rwmb: null,
          bz: null,
        },
      };
      this.editor.txt.html("");
      this.editor2.txt.html("");
      this.form.rldxActive = 0;
    },
    handleChange(file, fileList) {
      //验证上传文件的格式
      // const suffixReg = /(xls|xlsx|pdf|doc|docx|ppt|pptx)$/;
      // const point = file.name.lastIndexOf(".");
      // const suffix = file.name.substr(point + 1);
      // const isFile = suffixReg.test(suffix);
      // if (!isFile) {
      //   this.$message.error("请上传正确格式的文件 !");
      //   fileList.pop();
      //   return false;
      // }
      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        fileList.pop();
        return false;
      }
      //验证上传文件重复
      // let existFile = fileList
      //   .slice(0, fileList.length - 1)
      //   .find((f) => f.name === file.name);
      // if (existFile) {
      //   this.$message.error("当前文件已经存在!");
      //   fileList.pop();
      //   return false;
      // }
    },
    handleExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    submitUpload(status) {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          let solveTime = null;
          this.editForm.detail = this.editor.txt.html();
          this.editForm.jjfa = this.editor2.txt.html();
          if (!this.editForm.solveTime) {
            this.$message.error("请输入解决日期！");
            return;
          }
          //内部产品 && 解决方案 == 已解决 && 上线时间为空
          if (
            this.editForm.sfxytx != 0 &&
            this.editForm.solvePlan == 4 &&
            !this.editForm.sxsj
          ) {
            this.$message.error("请选择上线时间！");
            return;
          }
          if (
            this.editForm.sfxytx != 0 &&
            this.editForm.solvePlan == 4 &&
            !this.editForm.jjfa
          ) {
            this.$message.error("请输入解决方案！");
            return;
          }
          this.$refs.upload.submit();
          let { uploadFiles } = this.$refs.upload;
          let fileLen = uploadFiles.length;
          let form = new FormData();
          uploadFiles.forEach((item, index) => {
            form.append("files", item.raw);
          });
          this.fullscreenLoading = true;
          if (fileLen > 0) {
            //上传文件
            form.append("id", this.mxParams.id);
            form.append("type", "解决");
            return new Promise((resolve, reject) => {
              uploadFile(form)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message.success("上传成功！");
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                      showClose: true,
                    });
                  }
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            }).then((success) => {
              if (success.code == 0) {
                this.editForm.fileIds = success.data;
                this.saveForm(status);
              }
            });
          } else if (fileLen == 0) {
            this.saveForm(status);
          } else {
            this.$message.error(res.msg);
            return false;
          }
        } else {
          this.hiddenDialog(true);
        }
      });
    },
    handleDeleteFile(row) {
      deleteFile({ fileId: row.fileId, path: row.url }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.getData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleDownloadFile(row) {
      const filePath = row.absolutepath;
      const fileName = row.filename;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },

    giveFather() {
      this.parentDialog = false;
    },
    openPreview(row) {
      const url = row.url;
      window.open(url);
    },
    handleClickTabs(e) {
      this.activeEditor = e.index;
    },
    handleAddComment() {
      const params = {
        id: this.mxParams.id,
        status: this.editForm.status,
        content: this.editor3.txt.html(),
      };
      if (!params.content || checkVal(params.content)) {
        return;
      }
      saveComment(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.editor3.txt.html("");
          this.getData(true);
        }
      });
    },
    handleChangeProgress(e) {
      if (e == 100) {
        this.editForm.solvePlan = "4";
      } else {
        this.editForm.solvePlan = "";
      }
    },
    handeleChangeSolvePlan(e) {
      if (e == 4) {
        this.editForm.progress = 100;
      } else {
        this.editForm.progress = 0;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 40px;
}
.r {
  margin: 0 10px;
  .r_title {
    text-align: center;
    line-height: 40px;
    border-bottom: 2px solid #e4e7ed;
    box-sizing: border-box;
    height: 40px;
    margin-bottom: 15px;
  }
}
.zpsm-comment-item {
  margin-top: 15px;
  .top {
    display: flex;
    line-height: 30px;
    font-weight: bold;
    font-size: 15px;
    > div {
      margin-right: 15px;
    }
    > div:nth-of-type(1) {
      background-color: #8080ff;
      color: #fff;
      height: 30px;
      line-height: 30px;
      width: 30px;
      text-align: center;
      border-radius: 50%;
    }
  }
  .middle {
    line-height: 20px;
    color: #555;
    padding-left: 45px;
    margin: 10px 0;
  }
  .bottom {
    font-size: 12px;
    padding-left: 45px;
    color: #7f7f7f;
  }
}
</style>